import { useDispatch, useSelector } from 'react-redux';
import {
  IDIncomeVerificationStatus,
  VerificationFailureAction,
  VerificationType,
} from '@common/entities';
import { setIsApplicationLocked } from 'state/slices/fieldSettingsSlice';
import { setIsCompletionAllowed } from 'state/slices/idIncomeVerificationSlice';
import { RootState } from 'state/store';

const useHandleVerificationFailedWorkFlow = () => {
  const { idVerification, incomeVerification } = useSelector(
    (state: RootState) => state.idIncomeVerification,
  );

  const dispatch = useDispatch();

  const updateStoreForFailedVerificationWorkflow = (
    status: IDIncomeVerificationStatus | null,
    verificationFailureAction: VerificationFailureAction,
  ) => {
    if (status === null) return;
    if (status !== IDIncomeVerificationStatus.Failed) return;
    if (verificationFailureAction === VerificationFailureAction.LockdownTheApplication) {
      dispatch(setIsApplicationLocked(true));
    }
    if (verificationFailureAction === VerificationFailureAction.ApplicationCantBeCompleted) {
      dispatch(setIsCompletionAllowed(false));
    }
  };

  const handleVerificationFailedWorkFlow = (
    verificationType: VerificationType,
    status: IDIncomeVerificationStatus,
  ) => {
    if (status !== IDIncomeVerificationStatus.Failed) return;
    const { verificationFailureAction } =
      verificationType === VerificationType.IdentityVerification
        ? idVerification
        : incomeVerification;

    updateStoreForFailedVerificationWorkflow(status, verificationFailureAction);
  };

  return {
    handleVerificationFailedWorkFlow,
    updateStoreForFailedVerificationWorkflow,
  };
};

export default useHandleVerificationFailedWorkFlow;
